import axiosClient from "./axios.client";

export const login = (params) => {
    return axiosClient.post('authen/login', params);
}

export const getListAccount = (params) => {
    return axiosClient.post('cms/account/getListAccount', params);
}

export const addNewAccount = (params) => {
    return axiosClient.post('cms/account/addNewAccount', params);
}

export const getListBranches = (params) => {
    return axiosClient.post(`cms/branches/branches_list`, params);
}

export const addNewBranch = (params) => {
    return axiosClient.post('cms/branches/branches_create', params);
}

export const updateBranchById = (params) => {
    return axiosClient.post('cms/branches/branches_update', params);
}

export const getListRoles = () => {
    return axiosClient.get('cms/roles/getListRoles');
}

export const updateUserInfo = (params) => {
    return axiosClient.post('cms/account/updateUserInfo', params);
}


export const changeUserPassword = (param) => {
    return axiosClient.post('authen/changePassword', param);
}

export const getListCustomers = (params) => {
    return axiosClient.post('cms/customers/customers_list', params);
}

export const customers_create = (params) => {
    return axiosClient.post('cms/customers/customers_create', params);
}

export const customers_update = (params) => {
    return axiosClient.post('cms/customers/customers_update', params);
}

export const customers_delete = (params) => {
    return axiosClient.post(`cms/customers/customers_delete`, params);
}

export const employees_list = (params) => {
    return axiosClient.post(`cms/employees/employees_list`, params);
}

export const employees_create = (params) => {
    return axiosClient.post(`cms/employees/employees_create`, params);
}

export const employees_delete = (params) => {
    return axiosClient.post(`cms/employees/employees_delete`, params);
}

export const employees_update = (params) => {
    return axiosClient.post(`cms/employees/employees_update`, params);
}

export const getListPositions = (params) => {
    return axiosClient.get(`cms/positions/getListPositions?keyword=${params?.keyword}`);
}

export const positions_create = (params) => {
    return axiosClient.post(`cms/positions/positions_create`, params);
}

export const positions_delete = (params) => {
    return axiosClient.post(`cms/positions/positions_delete`, params);
}

export const positions_update = (params) => {
    return axiosClient.put(`cms/positions/positions_update`, params);
}

export const services_list = (params) => {
    return axiosClient.post(`cms/services/services_list`, params);
}

export const services_create = (params) => {
    return axiosClient.post(`cms/services/services_create`, params);
}

export const services_update = (params) => {
    return axiosClient.post(`cms/services/services_update`, params);
}

export const services_delete = (params) => {
    return axiosClient.post(`cms/services/services_delete`, params);
}

export const position_rules_create = (params) => {
    return axiosClient.post(`cms/position-rules/position_rules_create`, params);
}

export const position_rules_delete = (params) => {
    return axiosClient.post(`cms/position-rules/position_rules_delete`, params);
}

export const position_rules_list = (params) => {
    return axiosClient.post(`cms/position-rules/position_rules_list`, params);
}

export const position_rules_update = (params) => {
    return axiosClient.post(`cms/position-rules/position_rules_update`, params);
}

// export const customer_services_create = (params) => {
//     return axiosClient.post(`cms/customer-services/customer_services_create`, params);
// }

export const customer_services_create = (params) => {
    return axiosClient.post(`cms/customer-services/customer_services_create_v2`, params);
}

export const customer_services_update = (params) => {
    return axiosClient.post(`cms/customer-services/customer_services_update`, params);
}

export const customer_services_update_status = (params) => {
    return axiosClient.post(`cms/customer-services/customer_services_update_status`, params);
}

export const customer_services_active_list = (params) => {
    return axiosClient.post(`cms/customer-services/customer_services_active_list`, params);
}

export const customer_services_detail = (params) => {
    return axiosClient.post(`cms/customer-services/customer_services_detail_v2`, params);
}

export const service_sessions_list = (params) => {
    return axiosClient.post(`cms/sessions/service_sessions_list`, params);
}

export const service_sessions_detail = (params) => {
    return axiosClient.post(`cms/sessions/service_sessions_detail`, params);
}

export const service_sessions_delete = (params) => {
    return axiosClient.post(`cms/sessions/service_sessions_delete`, params);
}

export const service_sessions_create = (params) => {
    return axiosClient.post(`cms/sessions/service_sessions_create`, params);
}

export const positions_with_rules = (params) => {
    return axiosClient.post(`cms/positions/positions_with_rules`, params);
}

export const product_create = (params) => {
    return axiosClient.post(`cms/products/product_create`, params);
}

export const product_delete = (params) => {
    return axiosClient.post(`cms/products/product_delete`, params);
}

export const product_detail = (params) => {
    return axiosClient.post(`cms/products/product_detail`, params);
}

export const product_list = (params) => {
    return axiosClient.post(`cms/products/product_list`, params);
}

export const product_update = (params) => {
    return axiosClient.post(`cms/products/product_update`, params);
}

export const opening_order_list = (params) => {
    return axiosClient.post(`cms/inventory/opening_order_list`, params);
}

export const opening_order_create = (params) => {
    return axiosClient.post(`cms/inventory/opening_order_create`, params);
}

export const opening_order_detail = (params) => {
    return axiosClient.post(`cms/inventory/opening_order_detail`, params);
}

export const opening_order_cancel = (params) => {
    return axiosClient.post(`cms/inventory/opening_order_cancel`, params);
}

export const warehouse_list = (params) => {
    return axiosClient.post(`cms/warehouses/warehouse_list`, params);
}

export const warehouses_create = (params) => {
    return axiosClient.post(`cms/warehouses/warehouses_create`, params);
}

export const warehouses_update = (params) => {
    return axiosClient.post(`cms/warehouses/warehouses_update`, params);
}

export const warehouse_delete = (params) => {
    return axiosClient.post(`cms/warehouses/warehouse_delete`, params);
}

export const import_orders_create = (params) => {
    return axiosClient.post(`cms/import_orders/import_orders_create`, params);
}

export const import_orders_cancel = (params) => {
    return axiosClient.post(`cms/import_orders/import_orders_cancel`, params);
}

export const import_orders_get_detail = (params) => {
    return axiosClient.get(`cms/import_orders/import_orders_get_detail?id=${params?.id}`);
}

export const import_orders_list = (params) => {
    return axiosClient.post(`cms/import_orders/import_orders_list`, params);
}

export const export_orders_list = (params) => {
    return axiosClient.post(`cms/export_orders/export_orders_list`, params);
}

export const export_orders_get_detail = (params) => {
    return axiosClient.get(`cms/export_orders/export_orders_get_detail_v2?id=${params?.id}`);
}

export const export_orders_create = (params) => {
    return axiosClient.post(`cms/export_orders/export_orders_create`, params);
}

export const export_orders_cancel = (params) => {
    return axiosClient.post(`cms/export_orders/export_orders_cancel`, params);
}

export const product_search_for_export = (params) => {
    return axiosClient.post(`cms/export_orders/product_search_for_export`, params);
}

export const inventory_report = (params) => {
    return axiosClient.post(`cms/inventory/inventory_report`, params);
}

export const inventory_xnt_report = (params) => {
    return axiosClient.post(`cms/inventory/inventory_xnt_report`, params);
}

export const service_commission_report = (params) => {
    return axiosClient.post(`cms/reports/service_commission_report`, params);
}

export const consultant_commission_report = (params) => {
    return axiosClient.post(`cms/reports/consultant_commission_report_v2`, params);
}

export const consultant_commission_export = (params) => {
    return axiosClient.post(`cms/reports/consultant_commission_export`, params);
}

export const service_commission_export = (params) => {
    return axiosClient.post(`cms/reports/service_commission_export`, params);
}

export const consultant_service_detail = (params) => {
    return axiosClient.post(`cms/reports/consultant_service_detail_v2`, params);
}

export const consultant_product_detail = (params) => {
    return axiosClient.post(`cms/reports/consultant_product_detail_v2`, params);
}

export const inactive_service_customers = (params) => {
    return axiosClient.post(`cms/customer-services/inactive_service_customers`, params);
}

export const add_customer_care_log = (params) => {
    return axiosClient.post(`cms/customer-care/add_customer_care_log`, params);
}

export const delete_customer_care_log = (params) => {
    return axiosClient.post(`cms/customer-care/delete_customer_care_log`, params);
}

export const get_customer_care_log_detail = (params) => {
    return axiosClient.post(`cms/customer-care/get_customer_care_log_detail`, params);
}

export const list_customer_care_logs_nopage = (params) => {
    return axiosClient.post(`cms/customer-care/list_customer_care_logs_nopage`, params);
}

export const list_customer_care_logs = (params) => {
    return axiosClient.post(`cms/customer-care/list_customer_care_logs`, params);
}

export const update_customer_care_log = (params) => {
    return axiosClient.post(`cms/customer-care/update_customer_care_log`, params);
}

export const customers_import = (params) => {
    return axiosClient.post(`cms/customers/customers_import`, params);
}

export const products_import = (params) => {
    return axiosClient.post(`cms/products/products_import`, params);
}

export const services_import = (params) => {
    return axiosClient.post(`cms/services/services_import`, params);
}

export const customers_with_services = (params) => {
    return axiosClient.post(`cms/customers/customers_with_services`, params);
}

export const debt_list = (params) => {
    return axiosClient.post(`cms/customers/debt_list_v2`, params);
}

export const get_payment_detail = (params) => {
    return axiosClient.post(`cms/payments/get_payment_detail`, params);
}

export const cancel_payment = (params) => {
    return axiosClient.post(`cms/payments/cancel_payment_v2`, params);
}

export const add_payment = (params) => {
    return axiosClient.post(`cms/payments/add_payment_v2`, params);
}

export const get_info_debt_detail = (params) => {
    return axiosClient.post(`cms/payments/get_info_debt_detail_v2`, params);
}

export const get_total_revenue = (params) => {
    return axiosClient.post(`cms/revenue/get_total_revenue_v2`, params);
}

export const salaries_create = (params) => {
    return axiosClient.post(`cms/salaries/salaries_create`, params);
}

export const salaries_delete = (params) => {
    return axiosClient.post(`cms/salaries/salaries_delete`, params);
}

export const salaries_lock_update = (params) => {
    return axiosClient.post(`cms/salaries/lock_update`, params);
}

export const salaries_detail = (params) => {
    return axiosClient.get(`cms/salaries/salaries_detail?id=${params?.id}`);
}

export const salaries_list = (params) => {
    return axiosClient.post(`cms/salaries/salaries_list`, params);
}

export const salaries_update = (params) => {
    return axiosClient.post(`cms/salaries/salary_batches_update_all`, params);
}

export const salary_employee_income = (params) => {
    return axiosClient.post(`cms/salaries/salary_employee_income`, params);
}

export const get_dashboard_summary = (params) => {
    return axiosClient.post(`cms/dashboard/get_dashboard_summary_v2`, params);
}

export const get_daily_revenue = (params) => {
    return axiosClient.post(`cms/dashboard/get_daily_revenue_v2`, params);
}